// Settings module translations - Traditional Chinese
export default {
  title: '設定',
  subtitle: '個人化您的應用程式體驗',
  
  // Setting groups
  groups: {
    privacySecurity: '隱私與安全',
    appSettings: '應用程式設定',
    personalData: '個人資料',
    helpSupport: '幫助與支持'
  },
  
  // Setting items
  items: {
    privacySettings: {
      title: '隱私設定與政策',
      subtitle: 'AI功能、資料使用控制'
    },
    privacyCollection: {
      title: '個人資料收集',
      subtitle: '了解我們如何使用您的資料'
    },
    appSettings: {
      title: '應用程式設定',
      subtitle: '自訂應用程式行為'
    },
    notificationSettings: {
      title: '通知設定',
      subtitle: '管理推送通知偏好'
    },
    languageSettings: {
      title: '語言設定',
      subtitle: '選擇您的首選語言',
      sectionTitle: '選擇語言',
      sectionSubtitle: '選擇您的首選語言',
      note: '語言更改將立即生效，無需重新啟動應用程式'
    },
    bodyDataSetup: {
      title: '身體數據設定',
      subtitle: '配置健康數據參數'
    },
    helpFeedback: {
      title: '幫助與反饋',
      subtitle: '獲取幫助或提供建議',
      appTitle: 'CubeMeet',
      appSlogan: '分享激情，聚集快樂',
      appDescription: '支持多種團體活動和智能功能的綜合社交平台。',
      coreFeatures: '核心功能',
      contactSupport: '聯繫支持',
      emailFeedback: '電子郵件反饋',
      emailFeedbackDesc: '給我們發送電子郵件',
      features: {
        travel: { name: '旅行', desc: '智能旅行費用分攤，AI收據識別' },
        carpool: { name: '拼車', desc: '綠色出行，環保共乘' },
        dining: { name: '餐飲', desc: '活動聚會與餐飲' },
        shopping: { name: '購物', desc: '二手交易，本地市場' },
        fitness: { name: '健身', desc: '身體管理，健康追蹤' },
        todo: { name: '待辦事項', desc: '任務管理，協作清單' },
        ledger: { name: '帳本', desc: '個人和雲端會計' },
        groupBuying: { name: '團購', desc: '團體訂單，外賣共享' },
        toolbox: { name: '工具箱', desc: 'AI智能工具，智能食譜' }
      }
    }
  },
  
  // Messages
  messages: {
  logoutConfirm: '您確定要登出嗎？',
  deleteAccount: '刪除帳戶',
  deleteAccountConfirm: '刪除帳戶無法撤銷。您確定嗎？',
  deleteAccountNotice: '您的帳戶將立即被停用並登出。所有資料將於 {date} 從我們的伺服器上永久刪除。在此期間，您可以聯絡 support@cubemeet.app 撤銷此操作。',
  deleteAccountDisabledToast: '您的帳戶已被停用。所有資料將於 {date} 被永久刪除。如需恢復，請於 {date} 前聯絡 support@cubemeet.app。',
  settingsSaved: '設定已保存',
  settingsFailed: '無法保存設定'
  },
  
  // Privacy Settings Screen
  privacyScreen: {
    title: '隱私設定與政策',
  infoTitle: '隱私設定與政策',
  infoDescription: '在此您可控制 AI 功能、資料同步與隱私相關設置，以保護您的個人資訊。',
    privacyProtection: '隱私保護',
    privacyDescription: '我們尊重您的隱私，您可以完全控制您的資料使用方式。這些設定決定應用程式如何處理您的個人信息。',
    aiFeaturesControl: 'AI功能控制',
    aiPrivacyControl: 'AI隱私控制',
    aiPrivacySubtitle: '控制應用程式中AI技術的使用，以保護您的資料隱私',
    enableAiFeatures: '啟用AI功能',
    aiFeatureDescription: '包括文字識別、食物識別、智能推薦等AI功能',
    dataUsageSecurity: '資料使用安全',
    dataPrivacyControl: '資料隱私控制',
    dataPrivacySubtitle: '控制雲端儲存和資料共享，以確保您的隱私安全',
    cloudDataSharing: '雲端資料共享',
    cloudSharingDescription: '允許創建共享帳本，資料將同步到雲端以與他人協作',
    dataUsageExplanation: '資料使用說明',
    dataUsagePoint1: 'AI處理的資料僅用於提供相應功能',
    dataUsagePoint2: '資料傳輸使用加密保護',
    dataUsagePoint3: '不會儲存您的個人隱私信息',
    dataUsagePoint4: '您可以隨時關閉任何功能',
    privacyPolicyAndTerms: '隱私政策與條款',
    privacyPolicy: '隱私政策',
    termsOfService: '服務條款',
    futurePrivacySettings: '更多隱私設定',
    futurePrivacyDescription: '未來版本將添加更多隱私控制選項，如共享帳本、資料同步等'
  },

  // Privacy Policy Screen
  privacyPolicyScreen: {
    title: '隱私政策',
    dataCollection: '資料收集',
    dataCollectionContent: '我們致力於保護您的隱私和個人信息安全。本應用程式收集的信息僅用於提供更好的服務體驗，不會用於其他商業目的。',
    informationUse: '信息使用',
    informationUseContent: '• 您的個人信息僅用於應用程式功能的正常運作\n• 我們不會出售或向第三方分享您的個人信息\n• 所有資料傳輸均經過加密',
    dataSecurity: '資料安全',
    dataSecurityContent: '我們採用行業標準的安全措施來保護您的個人信息，包括資料加密、安全傳輸協議等。',
    userRights: '用戶權利',
    userRightsContent: '您有權隨時：\n• 查看我們收集的關於您的信息\n• 要求更正或刪除您的個人信息\n• 撤銷對資料處理的同意\n• 隨時關閉任何功能或刪除帳戶',
    contactUs: '聯繫我們',
    contactUsContent: '如對本隱私政策有任何疑問，請聯繫我們：\n電子郵件：privacy@cubemeet.com',
    lastUpdated: '最後更新：2025年1月1日'
  },

  // Terms of Service Screen
  termsOfServiceScreen: {
    title: '服務條款',
    acceptanceOfTerms: '接受條款',
    acceptanceContent: '使用本應用程式即表示您同意遵守以下服務條款。如果您不同意這些條款，請勿使用本應用程式。',
    serviceDescription: '服務描述',
    serviceDescriptionContent: 'CubeMeet 是一款社交生活應用程式，幫助用戶：\n• 管理個人和共享帳本\n• 組織團體活動，如旅行、餐飲、拼車\n• 與朋友分享生活時刻\n• 使用AI智能功能提升體驗',
    userResponsibilities: '用戶責任',
    userResponsibilitiesContent: '使用本應用程式時，您同意：\n• 提供準確、真實的信息\n• 不違反法律法規\n• 不侵犯他人權利\n• 不從事惡意行為或濫用服務',
    serviceLimitations: '服務限制',
    serviceLimitationsContent: '我們保留在以下情況下限制或終止服務的權利：\n• 違反服務條款\n• 技術維護需求\n• 法律和監管要求\n• 其他合理原因',
    disclaimer: '免責聲明',
    disclaimerContent: '本應用程式按“現狀”提供服務，我們對以下情況不承擔責任：\n• 服務中斷或資料丟失\n• 第三方服務問題\n• 用戶之間的爭議\n• 不可抗力因素',
    termsModification: '條款修改',
    termsModificationContent: '我們保留隨時修改這些條款的權利。重大變更將通過應用程式內通知告知用戶。繼續使用應用程式即表示您接受修改後的條款。',
    contactUs: '聯繫我們',
    contactUsContent: '如對本服務條款有任何疑問，請聯繫我們：\n電子郵件：my.cubemeet@gmail.com',
    lastUpdated: '最後更新：2025年1月1日'
  }
};